import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';

export const getDealType = createSelector(
  (state: Store) => state.dealManagement.commonDeal.dealType,
  (dealType) => dealType,
);
